import Rest from './base/Rest';

export default class AuthService extends Rest {
	static resource = 'login';
}
